let _ = t => t,
  _t;
import styledWithTheme from 'foundations-theming/utils';
import SVGWrapperBase from './SVGWrapperBase';
export default styledWithTheme(SVGWrapperBase)(_t || (_t = _`
  fill: ${0};
  font-size: 340%;
  background-color: ${0};
`), ({
  theme
}) => theme.color['text-core-default'], ({
  theme
}) => theme.color['fill-surface-default']);